"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledViewWrapper = exports.StyledLinkButton = exports.IconsWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _LinkButton = _interopRequireDefault(require("../../../Buttons/LinkButton"));

var _ParagraphText = _interopRequireDefault(require("../../../TextElements/BasicTextElements/ParagraphText"));

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var IconsWrapper = _styledComponents.default.span.withConfig({
  displayName: "Commonstyles__IconsWrapper",
  componentId: "sc-1dfjmtw-0"
})(["align-items:center;display:flex;& > *{", "}"], function (props) {
  return props.isRight ? (0, _styledComponents.css)(["margin-left:", ";"], props.theme.standardPadding) : (0, _styledComponents.css)(["margin-right:", ";"], props.zeroPadding ? 0 : props.theme.standardPadding);
});

exports.IconsWrapper = IconsWrapper;
var StyledLinkButton = (0, _styledComponents.default)(_LinkButton.default).withConfig({
  displayName: "Commonstyles__StyledLinkButton",
  componentId: "sc-1dfjmtw-1"
})(["padding-left:", ";"], function (props) {
  return props.theme.standardPadding;
});
exports.StyledLinkButton = StyledLinkButton;
var StyledViewWrapper = (0, _styledComponents.default)(_ParagraphText.default).withConfig({
  displayName: "Commonstyles__StyledViewWrapper",
  componentId: "sc-1dfjmtw-2"
})(["display:block;line-height:1.1875rem;min-height:", ";min-width:1.5rem;padding:", ";width:", ";transform:", ";white-space:pre-wrap;"], function (props) {
  return (0, _helperFunctions.joinDimensions)('+', 1.1875, props.theme.standardPadding, props.theme.standardPadding);
}, function (props) {
  return props.zeroPadding ? "".concat(props.theme.standardPadding, " ").concat(props.theme.standardPadding, " ").concat(props.theme.standardPadding, " 0") : props.theme.standardPadding;
}, function (props) {
  return props.inputWidth === 'fitText' ? 'auto' : '100%';
}, function (props) {
  return props.inViewMode ? 'translate(0,0)' : 'translate(0, -20000px)';
});
exports.StyledViewWrapper = StyledViewWrapper;